import { render } from "./BeneficiarioComponent.vue?vue&type=template&id=606fb201&scoped=true"
import script from "./BeneficiarioComponent.vue?vue&type=script&lang=js"
export * from "./BeneficiarioComponent.vue?vue&type=script&lang=js"

import "./BeneficiarioComponent.vue?vue&type=style&index=0&id=606fb201&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606fb201"]])

export default __exports__